import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL + '/new_order/senior_retoucher/post';
let needleUrl;
const options = {
    headers: {
        'Content-Type': 'multipart/form-data',
    }
};
function doneAdmin(payload) {
    needleUrl = `${url}/done-admin`;
    let newPayload = payload;
    if (Object.keys(payload).includes('role')) {
        needleUrl += '/' + payload.role;
        newPayload = payload.data;
    }
    return axios.post(needleUrl, newPayload, options)
        .then(response => {
            return {
                doneAdmin: response.data
            };
        });
}

function reDoneAdmin(payload) {
    needleUrl = `${url}/re-done-admin`;
    let newPayload = payload;
    if (Object.keys(payload).includes('role')) {
        needleUrl += '/' + payload.role;
        newPayload = payload.data;
    }
    return axios.post(needleUrl, newPayload, options)
        .then(response => {
            return {
                reDoneAdmin: response.data
            };
        });
}
function reDoneAdminEducation(payload) {
    needleUrl = `${url}/re-done-admin-education`;
    let newPayload = payload;
    if (Object.keys(payload).includes('role')) {
        needleUrl += '/' + payload.role;
        newPayload = payload.data;
    }
    return axios.post(needleUrl, newPayload, options)
        .then(response => {
            return {
                reDoneAdminEducation: response.data
            };
        });
}
export default {
    doneAdmin,
    reDoneAdmin,
    reDoneAdminEducation
};